﻿
cb.define([], function() {
	var AA_aa_optlist_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			//过滤条件枚举型选择全部时移除该条件
			var gridModel = viewmodel.getGridModel();
			gridModel.on('beforeLoad', function(data) {

				data.isDistinct = true;

				var common = data.condition.commonVOs;
				if(common != undefined && common.length > 0) {
					var datas = [];
					common.forEach(function(item) {
						if(item.itemName == "iStatus" && item.value1 == "3") {

						} else {
							datas.push(item);
						}

					});
					data.condition.commonVOs = datas;
				}
			});
			//批量在职
			viewmodel.on('batchInService', function(args) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if(selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择店员！', 'warning');
					return false;
				}

				var url = '/bill/batchDo?action=inService';
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: url,
						method: 'POST'
					}
				});

				var datas = [];
				var length = selectedRows.length;
				for(var i = 0; i < length; i++) {
					datas.push({
						"id": selectedRows[i]["id"],
						"iStatus": selectedRows[i]["iStatus"],
					});
				}
				var params = {
					billnum: "aa_optlist",
					data: JSON.stringify(datas)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');
					viewmodel.execute('refresh');
				});
			});
			//批量离职
			viewmodel.on('batchTurnOver', function(args) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if(selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择店员！', 'warning');
					return false;
				}

				var url = '/bill/batchDo?action=turnOver';
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: url,
						method: 'POST'
					}
				});

				var datas = [];
				var length = selectedRows.length;
				for(var i = 0; i < length; i++) {
					datas.push({
						"id": selectedRows[i]["id"],
						"iStatus": selectedRows[i]["iStatus"],
					});
				}
				var params = {
					billnum: "aa_optlist",
					data: JSON.stringify(datas)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');
					viewmodel.execute('refresh');
				});
			});
			
		}
	}
	try {
		module.exports = AA_aa_optlist_VM_Extend;
	} catch(error) {

	}
	return AA_aa_optlist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_optlist_VM.Extend.js